import { gql } from '@apollo/client';
import { BizAoiAttributeAccessCodeInput } from '../../../aoi-platform/graphql/mutations/upsertAoiAttribute';
import { BizAoiProduceResult, PRODUCE_RESULT_FIELDS } from './produceResult';

/**
 * 新建 AOI (几何 + 级别 + 基础属性一次性提交)。
 *
 * <p>zipcode 由后端按中心点反解, 不需要前端传; 返回里带 zipcode / aoiId / asyncTaskId。
 */
export const CREATE_BIZ_AOI = gql`
  mutation CreateBizAoi($input: BizAoiCreateInput!) {
    createBizAoi(input: $input) {
${PRODUCE_RESULT_FIELDS}
    }
  }
`;

export interface AoiPointInput {
    lng: number;
    lat: number;
    remark?: string | null;
}

export interface BizAoiCreateInput {
    geometryGeoJson: string;
    /** LEVEL_1 | LEVEL_2 */
    aoiLevel: string;
    name?: string | null;
    typeCode?: string | null;
    entryPoints?: AoiPointInput[] | null;
    parkingPoints?: AoiPointInput[] | null;
    accessCodes?: BizAoiAttributeAccessCodeInput[] | null;
    deliveryTime?: string | null;
}

export interface CreateBizAoiResponse {
    createBizAoi: BizAoiProduceResult;
}
